import zoomOutIcon from '../../../assets/icons/zoom_out.svg';
import { TImgContent } from '../../../utils/types/agrocraftArtisan';
import { useZoomOutMutation } from '../../../services/agrocraftArtisan';
import { useAppDispatch } from '../../../storeHook';
import { showAlert } from '../../../reduxActions/alert';
import './index.scss';
import { CircularProgress, Tooltip } from '@mui/material';

type TProps = {
  img: TImgContent;
  sessionId: number;
  prompt: string;
  setIsScrollToLatest: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  chatId: number;
};

export const ZoomOut = ({
  img,
  sessionId,
  prompt,
  setIsScrollToLatest,
  chatId,
}: TProps) => {
  const dispatch = useAppDispatch();

  const [zoomOutAPI, { isLoading }] = useZoomOutMutation();

  const onZoomOut = () => {
    setIsScrollToLatest(true);
    zoomOutAPI({
      sessionId,
      data: {
        task_id: img.task_id,
        api_type: img.api_type,
        index: img.index,
        prompt: prompt,
        chat_id: chatId,
      },
    })
      .unwrap()
      .then(() => {
        dispatch(
          showAlert({
            content: 'Image Zoom Out successfull',
          })
        );
      })
      .catch(() => {});
  };

  const isDisabled = img.outpaint_flag || isLoading;

  return (
    <div>
      <Tooltip title="Enlarge image">
        <a
          onClick={() => !isDisabled && onZoomOut()}
          className={`flex items-center gap-2 ${
            isDisabled ? 'disabled' : ''
          }`}>
          <img src={zoomOutIcon} />
          {isLoading && (
            <CircularProgress
              color="inherit"
              thickness={5}
              style={{ width: 16, height: 16 }}
            />
          )}
        </a>
      </Tooltip>
    </div>
  );
};
